import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Home from './pages/Home';
import UserDashboard from './pages/UserDashboard';
import IssuerPortal from './pages/IssuerPortal';
import Verify from './pages/Verify';
import About from './pages/About';
import NotFound from './pages/NotFound';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/home" element={<Home />} />
      <Route path="/user-dashboard" element={<UserDashboard />} />
      <Route path="/issuer" element={<IssuerPortal />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/about" element={<About />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Router>
);


